import { render, staticRenderFns } from "./ConfigurationComparison.vue?vue&type=template&id=bfcfe968&scoped=true&"
import script from "./ConfigurationComparison.vue?vue&type=script&lang=js&"
export * from "./ConfigurationComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcfe968",
  null
  
)

export default component.exports